/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Water_ViewInputs */

const cs_enum_water_view = /** @type {(inputs: Enum_Water_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výhled na vodu`)
};

const en_enum_water_view = /** @type {(inputs: Enum_Water_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Water view`)
};

/**
* | output |
* | --- |
* | "Water view" |
*
* @param {Enum_Water_ViewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_water_view = /** @type {((inputs?: Enum_Water_ViewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Water_ViewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_water_view(inputs)
	return cs_enum_water_view(inputs)
});